import axios from "axios";
import store from "../store/store";
import qs from "qs";
import cconfig from "@assets/config";

const ajax = axios.create();
ajax.defaults.headers = JSON.parse(JSON.stringify(axios.defaults.headers));
ajax.defaults.headers.hasToken = true;
ajax.defaults.headers.post["Content-Type"] = "application/json";
ajax.defaults.baseURL = cconfig.api.reqApi;
// ajax.defaults.baseURL='/api/bb'

const interceptor_re = (config) => {
  //console.error('common---------',config)
  if (config.method == "get" || config.method == "delete") {
    //data转params
    config.params = {
      ...config.params,
      ...config.data,
    };
  }
  if (config.headers["Content-Type"] && config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
    //json转form字符串
    config.data = qs.stringify(config.data);
  }
  if (config.headers.hasToken) {
    //是否需要token
    config.headers.Authorization = `Bearer ${store.state.token}`;
    //store.state.token=null
  }

  //console.error('request', config)
  return config;
};
ajax.interceptors.request.use(interceptor_re);
ajax.interceptors.response = axios.interceptors.response;
// ajax.interceptors.response.use(null, async (ex) => {
//     // axios.interceptors.response.handlers.forEach((item)=>{
//     //     item.rejected(ex)
//     // })
//     // //错误
//     // if (ex.response) {
//     //     switch (ex.response.status) {
//     //         case 401:
//     //             store.dispatch('loginModule/exit')
//     //             break;
//     //             let host=cconfig.api.auth
//     //             //console.error('host---',host)
//     //             // 返回 401 重新获取token
//     //             let data=store.getters['getAuth']
//     //             //console.error('host---',data)
//     //             let token = await getToken({ host: host,data:data })
//     //             store.commit('setToken', token.access_token)
//     //             //console.error('token', token)
//     //             return ajax(ex.config)
//     //     }
//     // }
//     // return Promise.reject(ex);

// })

//获取token
const getToken = async ({
  host = null,
  data = {
    grant_type: "custom_credentials",
    client_id: "webchat.program",
    scope: "synair",
    from_type: "weapp",
    openId: "oPv8N5JHqCqjtybz_X85lLeQa-so",
    unionId: "omhT8jvBScIHZ-ff2SA-remVKpjE",
  },
}) => {
  return request({
    host: host,
    method: "post",
    url: "/connect/token",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      hasToken: false,
    },
  });
};
const request = async ({ host = null, headers = {}, hasToken = true, url, method, data = null, params = null }) => {
  if (host) {
    url = `${host}${url}`;
  }

  return ajax({
    method: method,
    url: url,
    data: data,
    headers: headers,
    hasToken: hasToken,
    params: params,
  })
    .then((re) => {
      if (re && re.data) return re.data;
    })
    .catch((ex) => {
      throw ex;
    });
};

export default {
  request,
};
